import { useState, useEffect } from 'react';
import ControlPresupuesto from './components/ControlPresupuesto';
import Formulario from './components/Formulario';
import Listado from './components/Listado';
import Presupuesto from './components/Presupuesto';

function App() {
  const [presupuesto, guardarPresupuesto] = useState(0);
  const [restante, guardarRestante] = useState(0);
  const [
    mostrarfomulariopresupuesto,
    cambiarEstadoMostrarFormularioPresupuesto,
  ] = useState(true);
  const [gastos, guardarGastos] = useState([]);
  // state para guardar gasto
  const [gasto, guardarGasto] = useState({});
  // state para controlar creacionGasto
  const [controlgasto, guardarControlGasto] = useState(false);

  // useEffect que actualiza el restante
  useEffect(() => {
    // para control de creacion de gasto
    if (controlgasto) {
      guardarGastos([...gastos, gasto]);
    }

    // Para control del restante del presupuesto
    const presupuestoRestante = restante - gasto.cantidadgasto;
    guardarRestante(presupuestoRestante);

    guardarControlGasto(false);
  }, [gasto]);

  return (
    <div className='container'>
      <header>
        <h1>Presupuesto</h1>

        <div className='contenido-principal contenido'>
          {mostrarfomulariopresupuesto ? (
            <Presupuesto
              guardarPresupuesto={guardarPresupuesto}
              guardarRestante={guardarRestante}
              cambiarEstadoMostrarFormularioPresupuesto={
                cambiarEstadoMostrarFormularioPresupuesto
              }
            />
          ) : (
            <div className='row'>
              <div className='one-half column'>
                <Formulario
                  guardarGasto={guardarGasto}
                  guardarControlGasto={guardarControlGasto}
                />
              </div>
              <div className='one-half column'>
                <Listado gastos={gastos} />
                <ControlPresupuesto
                  presupuesto={presupuesto}
                  restante={restante}
                />
              </div>
            </div>
          )}
        </div>
      </header>
    </div>
  );
}

export default App;
